import React, { useState } from 'react';
import Helmet from 'react-helmet';
import _ from 'lodash';
import Joi from 'joi-browser';

import { validationByJoi } from '../utilities/commonValidation';
import {
  API_FLAG,
  HEADER_CONSTANTS,
  JOINING_FLAG,
  LEGAL_PERSONALITIES,
  MAP_LEGAL_PERSONALITIES,
  PREFECTURE_GROUPS,
  PREFECTURE_LISTS,
  ONE_MASTER_FLAG,
  FIELD_WORK_HOUR_ZONES,
  maxiileSize,
  CALL_FROM_PAGE,
  PARTNER_COMPANY_PERSONAL_TYPE,
  CORPORATION_PERSONAL_NAME,
  CORPORATION_PERSONAL_KANA,
  PARTNER_COMPANY_REGISTER_LOAD_FROM
} from '../utilities/constants';
import {
  FORM_MODE,
  useAgencyRegistrationApplicationForm,
} from '../components/useAgencyRegistrationApplicationForm';
import dialogLoader from '../utilities/dialogLoader';
import EventMg from '../utilities/EventManager';
import masterSlideLoader from '../utilities/masterSlideLoader';
import { messageUtility } from '../utilities/messageUtility';
import regex from '../utilities/validateRegex';
import { convertPostalCode, convertHiragana } from '../utilities/stringUtil';
import PartnerCompanyRegisterConfirmDialog from '../components/PartnerCompanyRegisterConfirmDialog';
import * as dialog from '../components/FieldTreeDialog';
import { FIELD_TREE_EVENTS } from '../components/FieldTreeEvents';
import { MasterPageHeader } from '../components/PageHeader';
import {
  FormList,
  FormElement,
  FormListItem,
} from '../components/CommonFormComponents';
import { Description } from '../components/Description';
import { Tel } from '../components/Tel';
import { PostalCode } from '../components/PostalCode';
import { ArrowDownIcon } from '../components/icons/ArrowDownIcon';
import { CompanyService } from '../services/Companies';
import FieldApi from '../services/field/FieldApi';
import FieldTreesApi from '../services/fieldTrees/FieldTreesApi';
import { PartnerCompanyAddDialog } from '../components/PartnerCompanyAddDialog';
import Information from '../components/modals/common/Information';
import { FormInformationDialog } from '../components/FormInformationDialog';
import SessionStorageService from '../services/utilities/SessionStorageService';
import CompanyLogo from '../components/image/CompanyLogo';
import { HEAD_OFFICE_OPTION } from '../components/PartnerCompanyBranchDropdown';
import ImageUtility from '../utilities/imageUtility';
import {
  loadFromFieldTreePage,
  loadFromPartnerCompanies,
  loadFromAgencyRegister,
} from '../utilities/partnerCompanyRegisterUtil';
import {
  AddPartnerCompanyFieldTreeSuccessDialog,
  DupulicateCompanyDialog,
} from '../components/FieldTreeDialog';
import { isNullOrEmpty } from '../utilities/stringUtil';
import { RadioButtonIcon } from '../components/icons/RadioButtonIcon';
import { addPartnerCompanySucessDialog } from '../styles/organisms/add-partner-company-success-dialog.scss';

export class PartnerCompanyPersonalRegister extends React.Component {
  constructor(props) {
    super(props);

    if (!this.props.view.state.loadFrom) {
      return window.location.replace('/error-permission'); //BLDE_V2-53962【B-685】案件で削除予定
    }

    this.state = {
      requiredInput: {
        // 必須入力項目
        columns: [
          'name',
          'kana',
          'postal_code',
          'prefectures_code_id',
          'city_name',
          'tel',
          'one_owner_flag',
        ], // 必須項目名
        total: 7, // 必須総数
        count: 1, // 入力数
      },
      validate: {
        validated: true, // 登録ボタン押下済みフラグ
        invalid: false, // 入力内容エラー
        messages: {}, // エラー内容
      },
      formValues: {
        building_name: '',
        city_name: '',
        company_number: '',
        fax: '',
        name: '',
        kana: '',
        postal_code: '',
        prefectures_code_id: '',
        street_number: '',
        tel: '',
        representative: '',
        work_hour_zone_day_flag: 1,
        work_hour_zone_night_flag: 1,
        work_hour_zone_midnight_flag: 1,
        joining_flag: '',
        parent_tree_id: '',
        personal_flag: 1,
        prime_contractors_company_branch_id: '',
        private_partner_company_flag: 0, // 別途業者
        company_selected_counts: 0,
        noPostalcode: true,
        one_owner_flag: 0,
      },
      confirmValidate: '',
      showConfirmDialog: false,
      workHourZoneSetting: {},
      image: {
        // アップロード画像
        file: '', // バイナリ
        path: '', // 画像URL
        isSet: false, // 画像セットフラグ
      },
      visibleDialogFlag: false,
      errorMessage: '',
      isLoading: false, // 連打防止フラグ
    };

    this.events = {
      form: {
        handleInput: this.handleInput,
        submit: this.submit, // 登録
        validate: this.validate, // バリデーション
        close: this.close,
        setImage: this.setImage,
        deleteImage: this.deleteImage,
        goBackToSearch: this.goBackToSearch,
      },
      confirm: {
        close: this.closeConfirm,
        confirmCreateFieldTree: this.confirmCreateFieldTree,
        confirmCreatePartnerCompany: this.confirmCreatePartnerCompany,
        handleConfirmInput: this.handleConfirmInput,
        submit: this.submit,
        resetUpdatingFlag: () => {
          this.updatingFlag = false;
        },
      },
    };

    this.schema = {
      name: Joi.string()
        .required()
        .max(255), // 氏名または屋号
      kana: Joi.string()
        .label('hiragana')
        .regex(regex.pattern.hiragana)
        .max(512)
        .required(), // 氏名または屋号（ふりがな）
      postal_code: Joi.string()
        .label('zip')
        .regex(regex.pattern.zip)
        .required(), // 郵便番号
      prefectures_code_id: Joi.number().required(), // 都道府県
      city_name: Joi.string()
        .label('city_name')
        .required()
        .max(512), // 市区町村
      street_number: Joi.string()
        .max(512)
        .allow(null, ''), // 丁目・番地
      building_name: Joi.string()
        .max(512)
        .allow(null, ''), // 建物名・部屋番号等
      tel: Joi.string()
        .label('tel')
        .regex(regex.pattern.tel)
        .required(), // 電話番号
      fax: Joi.string()
        .label('fax')
        .regex(regex.pattern.tel)
        .allow(null, ''), // FAX
      one_owner_flag: Joi.number().required(),
    };

    this.submitRef = React.createRef(); // 登録ボタン要素
    this.updatingFlag = false; // 連打防止フラグ
  }

  handleConfirmInput = (value, key) => {
    this.setState(
      {
        formValues: {
          ...this.state.formValues,
          [key]: value,
        },
      },
      () => {
        if (
          key !== 'representative' &&
          key !== 'private_partner_company_flag'
        ) {
          this.confirmValidate();
        }
      }
    );
  };

  closeConfirm = () => {
    this.setState({
      showConfirmDialog: false,
      confirmValidate: '',
    });
  };

  confirmCreatePartnerCompany = () => {
    const formValues = _.cloneDeep(this.state.formValues);
    return this.createNewCompany(formValues, true);
  };

  getFieldId = () => {
    // BLDE_V2-41999: 施工体系図から表示された場合、施工体系図から渡された現場IDを使用
    if (this.fromFieldTreePage()) {
      const fieldId = !_.isUndefined(this.props.view.state.field_id)
        ? this.props.view.state.field_id
        : this.props.view.state.listData.field_id;
      return fieldId;
    }
    return SessionStorageService.getFieldId();
  };

  // 協力会社一覧にない企業を追加 + 現場体制に追加
  confirmCreateFieldTree = async (
    formValues = this.state.formValues,
    company,
    createFlag = false
  ) => {
    if (!this.confirmValidate()) {
      return false;
    }
    const fieldId = this.getFieldId();
    // 現場体制の親会社IDを設定（元請の場合は'0'）
    const parentTreeId = !_.isUndefined(this.props.view.state.field_tree_id)
      ? this.props.view.state.field_tree_id
      : !_.isUndefined(this.props.view.state.listData.field_tree_id)
      ? this.props.view.state.listData.field_tree_id
      : '0';
    const primeContractorsCompanyBranchId = !_.isUndefined(
      this.props.view.state.jvCompanyBranchId
    )
      ? this.props.view.state.jvCompanyBranchId
      : this.props.view.state.listData.prime_contractors_company_branch_id;

    if (!isNullOrEmpty(formValues.company_number)) {
      formValues.personal_flag = 0;
    } else {
      formValues.personal_flag = 1;
    }

    const params = {
      company: {
        name: formValues.name,
        kana: formValues.kana,
        postal_code: !_.isUndefined(formValues.postal_code)
          ? convertPostalCode(formValues.postal_code)
          : '',
        prefectures_code_id: formValues.prefectures_code_id,
        city_name: formValues.city_name,
        street_number: formValues.street_number,
        building_name: formValues.building_name,
        tel: formValues.tel,
        fax: formValues.fax,
        personal_flag: formValues.personal_flag, // 個人
        joining_flag: JOINING_FLAG.contractorInherent.id, // 未加入法人は0
      },
      company_id: 0, // 未加入法人の場合0
      parent_tree_id: parentTreeId,
      prime_contractors_company_branch_id: primeContractorsCompanyBranchId,
      representative: formValues.representative,
      work_hour_zone_day_flag: formValues.work_hour_zone_day_flag,
      work_hour_zone_night_flag: formValues.work_hour_zone_night_flag,
      work_hour_zone_midnight_flag: formValues.work_hour_zone_midnight_flag,
      private_partner_company_flag: formValues.private_partner_company_flag, // 別途業者
      // company_id: null // TODO: 法人会社の場合必要かもしれない
    };

    if (!_.isUndefined(company)) {
      params.company = {
        ...params.company,
        ...company.company,
      };

      if (!createFlag) {
        // Buildee加入済みで自社の協力会社一覧にない場合
        params.company_id = _.has(company, 'company.id')
          ? company.company.id
          : 0;
        // 選択した会社情報がある場合、joining_flagは１ (PartnerCompanyRegisterと揃える)
        params.company.joining_flag = 1;
      }
    }
    // 法人番号がある場合paramsに追加
    if (!_.isEmpty(formValues.company_number)) {
      params.company.company_number = formValues.company_number;
    }

    if (params.company.personal_flag === ONE_MASTER_FLAG.personal.id) {
      params.company.one_owner_flag = formValues.one_owner_flag;
    }

    // 法人格がある場合paramsに追加
    if (!_.isUndefined(formValues.juridical_personality_code)) {
      params.company.juridical_personality_code =
        formValues.juridical_personality_code;
    }
    // 画像セット
    if (this.state.image.isSet) {
      params.icon_image = this.state.image.file;
    }

    // requestWithTokenがasyncのため、awaitを外さないこと
    await FieldTreesApi.createWithCompany(fieldId, params)
      .then(response => {
        if (response.result) {
          // 重複データが既にある場合にはエラーダイアログを表示する
          if (_.get(response, 'duplicate_flag') === true) {
            dialogLoader.show(DupulicateCompanyDialog, {
              companyNumber: this.state.formValues.company_number,
              onClose: () => {
                dialogLoader.close();
              },
            });
            return;
          }

          this.setState({ showConfirmDialog: false }, () => {
            // 重複データが既にある場合にはエラーダイアログを表示する
            if (_.get(response, 'duplicate_flag') === true) {
              dialogLoader.show(DupulicateCompanyDialog, {
                companyNumber: this.state.formValues.company_number,
                onClose: () => {
                  dialogLoader.close();
                },
              });
              return;
            }

            this.redirectFieldtree();
            const fieldTree = _.get(response, 'data.entities.field_tree');
            dialogLoader.show(AddPartnerCompanyFieldTreeSuccessDialog, {
              companyName: fieldTree.company_name,
              onConfirm: () => {
                dialogLoader.close();
                masterSlideLoader.show('PartnerBox', {
                  state: { id: fieldTree.id },
                });
              },
              onCancel: () => {
                dialogLoader.close();
              },
            });
          });
        }
      })
      .finally(() => {
        this.updatingFlag = false;
      });
  };

  redirectFieldtree = (reopenSearch = false) => {
    const state = { id: 1 };
    if (_.has(this.props.view.state, 'listData.options')) {
      state.nodes = this.props.view.state.listData.options.nodes;
      state.options = this.props.view.state.listData.options;
    }
    if (reopenSearch) {
      state.reopenSearch = true;
      state.cacheParam = _.has(this.props.view.state, 'listData.cacheParam')
        ? this.props.view.state.listData.cacheParam
        : {};
      if (_.has(this.props.view.state, 'options')) {
        state.nodes = this.props.view.state.options.nodes;
        state.options = this.props.view.state.options;
      }
    }

    masterSlideLoader.show('FieldTreePage', { state }, this.props.vw);
  };

  /**
   * 登録 - Buildee未加入登録 - 個人・法人
   */
  createCompany = async () => {
    let workHourZone = {};
    let workHourZoneSetting = {};
    // 施工体制から遷移した場合は現場情報から作業時間帯設定を取得する
    if (this.fromFieldTreePage()) {
      workHourZoneSetting = await this.getWorkHourZoneSetting();
      workHourZone = {
        work_hour_zone_day_flag: workHourZoneSetting.work_hour_zone_day_flag
          ? 1
          : 0,
        work_hour_zone_night_flag: workHourZoneSetting.work_hour_zone_night_flag
          ? 1
          : 0,
        work_hour_zone_midnight_flag: workHourZoneSetting.work_hour_zone_midnight_flag
          ? 1
          : 0,
      };
    }
    this.setState(
      {
        workHourZoneSetting,
        formValues: {
          ...this.state.formValues,
          ...workHourZone,
        },
      },
      () => {
        this.showConfirmDialog();
      }
    );
  };

  componentDidMount() {
    if (!_.isUndefined(this.props.view.state.listData)) {
      const listData = this.props.view.state.listData;
      const isCorporate = !_.isEmpty(listData.selected.company_number);
      this.setState(
        {
          formValues: {
            ...this.state.formValues,
            building_name: listData.selected.building_name,
            city_name: listData.selected.city_name,
            company_number: listData.selected.company_number,
            juridical_personality_code:
              MAP_LEGAL_PERSONALITIES[listData.selected.company_kind],
            fax: listData.selected.fax,
            name: listData.selected.name,
            kana: convertHiragana(listData.selected.kana),
            postal_code: listData.selected.postal_code,
            prefectures_code_id: listData.selected.prefectures_code_id,
            street_number: listData.selected.street_number,
            tel: listData.selected.tel,
            representative: '',
            work_hour_zone_day_flag: 0,
            work_hour_zone_night_flag: 0,
            work_hour_zone_midnight_flag: 0,
            //
            joining_flag: '0', // 0=Buildee未加入
            parent_tree_id: listData.field_tree_id,
            personal_flag: isCorporate
              ? ONE_MASTER_FLAG.corporation.id
              : ONE_MASTER_FLAG.personal.id, // 法人・個人
            prime_contractors_company_branch_id:
              listData.prime_contractors_company_branch_id,
            private_partner_company_flag: 0, // TODO: 別当業者フラグ, 元請の配下に登録する場合フォームで設定可能
            prime_company_name: listData.prime_company_name,
            noPostalcode: _.isEmpty(listData.selected.postal_code),
          },
        },
        () => {
          // 必須項目の入力数を動的に設定
          this.checkRequired();
        }
      );
    }
    if (this.fromAgencyRegister()) {
      return;
    }

    if (
      this.fromFieldTreePage() &&
      _.isUndefined(this.props.view.state.listData)
    ) {
      // 「一覧にない個人事業主を新規登録」を選択した場合はthis.props.view.state.field_tree_id
      this.setState({
        formValues: {
          ...this.state.formValues,
          parent_tree_id: this.props.view.state.field_tree_id,
        },
      });
    }
  }

  redirectPartnerCompanies = (reopenSearch = false) => {
    const state = { id: 1 };
    if (reopenSearch) {
      state.reopenSearch = true;
      state.cacheParam = _.has(this.props.view.state, 'listData.cacheParam')
        ? this.props.view.state.listData.cacheParam
        : {};
    }

    masterSlideLoader.show('PartnerCompanies', { state }, this.props.vw);
  };

  redirectAgencyRegister = (reopenSearch = false) => {
    if (_.has(this.props, 'view.state.listData.cacheParam')) {
      this.props.onClose(this.props.view.state.listData.cacheParam);
    } else if (reopenSearch) {
      this.props.onClose({});
    } else {
      this.props.onClose();
    }
  };

  // 閉じる
  close = () => {
    dialogLoader.show(dialog.CloseEditView, {
      callback: {
        close: () => {
          dialogLoader.close();
        },
        clear: () => {
          dialogLoader.close();
          if (this.fromFieldTreePage()) {
            this.redirectFieldtree();
          } else if (this.fromAgencyRegister()) {
            this.props.onClose();
          } else {
            this.redirectPartnerCompanies();
          }
        },
      },
    });
  };

  handleInput = (name, value) => {
    this.setState(
      {
        formValues: {
          ...this.state.formValues,
          [name]: value,
        },
      },
      () => {
        this.validate(true, name);
        this.checkRequired();
      }
    );
  };

  /**
   * 必須入力状況チェック
   */
  checkRequired() {
    const formValues = _.cloneDeep(this.state.formValues);
    // 必須チェック
    const requiredInput = _.cloneDeep(this.state.requiredInput);
    const isCorporate = !_.isEmpty(this.state.formValues.company_number);
    let cnt = 0;

    const result = validationByJoi(Joi.object().keys(this.schema), formValues);
    if (isCorporate) {
      requiredInput.columns = _.pullAll(requiredInput.columns, [
        'name',
        'postal_code',
        'prefectures_code_id',
        'city_name',
        'one_owner_flag',
      ]);

      // 郵便番号が登録されてない場合、必須の入力項目とする
      if (this.state.formValues.noPostalcode) {
        requiredInput.columns.push('postal_code');
      }
    }
    // 会社情報
    _.each(requiredInput.columns, column => {
      if (
        (formValues[column] === false ||
          formValues[column] ||
          column === 'one_owner_flag') &&
        !result.messages[column]
      ) {
        cnt++;
      }
    });

    requiredInput.count = cnt;
    requiredInput.total = _.size(requiredInput.columns);

    this.setState({
      requiredInput,
    });
  }

  /**
   * 入力値の有効判定
   *  単数項目チェック
   */
  validate = (e, targetName) => {
    if (!e) {
      return;
    }

    const result = validationByJoi(this.schema, this.state.formValues);

    const validate = _.cloneDeep(this.state.validate);
    const name = _.isEmpty(targetName) ? e.target.name : targetName;
    // 支店情報のバリデートチェック
    if (result.messages[name]) {
      validate.messages[name] = result.messages[name];
    } else {
      delete validate.messages[name];
    }
    validate.invalid = Object.keys(validate.messages).length > 0;

    this.setState({ validate });
    if (
      name === 'name' ||
      name === 'prefectures_code_id' ||
      name === 'city_name' ||
      name === 'street_number' ||
      name === 'tel'
    ) {
      return !(name in validate.messages);
    }
  };

  /**
   * 入力値の有効判定
   *  全項目チェック
   */
  validateAll = () => {
    const result = validationByJoi(this.schema, this.state.formValues);

    const validate = {
      invalid: false, // 入力内容エラー
      messages: {}, // エラー内容
    };
    // 登録ボタン押下時の処理
    _.each(result.messages, (value, key) => {
      if (key !== 'undefined') {
        validate.messages[key] = value;
      }
      validate.invalid = true;
    });

    this.setState({ validate });
    this.checkRequired();
    return Object.keys(validate.messages).length === 0;
  };

  confirmValidate = () => {
    const { formValues } = _.cloneDeep(this.state);
    const workHourValues = [
      formValues.work_hour_zone_day_flag,
      formValues.work_hour_zone_night_flag,
      formValues.work_hour_zone_midnight_flag,
    ];
    const result = _.some(workHourValues, value => {
      return value === FIELD_WORK_HOUR_ZONES.on.id;
    });
    // 作業時間帯
    if (result) {
      this.setState({
        confirmValidate: '',
      });
    } else {
      this.setState({
        confirmValidate: '必須です',
      });
    }
    return result;
  };

  /**
   * 類似会社一覧取得パラメータ取得
   *
   * @return {object} 類似会社一覧取得パラメータ
   * */
  createFetchSimilarParam = () => {
    /*
     * TODO：施工体制から追加する場合と協力会社一覧から追加する場合で設定するパラメータが異なる
     * BLDE_V2-28695では施工体制から追加する場合のみ対応する
     * 協力会社一覧から追加する場合についてはBLDE_V2-28401で対応する
     * */
    const param = {
      parent_company_branch_id: this.props.view.state.parent_company_branch_id,
      name: this.state.formValues.name,
      kana: this.state.formValues.kana,
      tel: this.state.formValues.tel,
    };
    if (this.fromAgencyRegister()) {
      param.agency_flag = true;
    }
    if (this.props.view.state.field_tree_id !== 0) {
      // 元請会社の配下じゃない場合[fieldTreeId]も必要
      param.field_tree_id = this.props.view.state.field_tree_id;
    }
    return param;
  };

  /**
   * 類似会社一覧ダイアログを表示する
   * */
  showSimilarityDialog = (similar = true) => {
    const jvFieldTree = this.props.view.state.jvFieldTree;
    dialogLoader.show(
      PartnerCompanyAddDialog,
      {
        state: {
          company: {
            // company_number: '',
            company_number: this.state.formValues.company_number,
            name: this.state.formValues.name,
            kana: this.state.formValues.kana,
            address:
              PREFECTURE_LISTS[this.state.formValues.prefectures_code_id] +
              this.state.formValues.city_name +
              this.state.formValues.street_number +
              this.state.formValues.building_name,
            city_name: this.state.formValues.city_name,
            street_number: this.state.formValues.street_number,
            building_name: this.state.formValues.building_name,
            tel: this.state.formValues.tel,
            fax: this.state.formValues.fax,
            postal_code: this.state.formValues.postal_code,
            prefectures_code_id: this.state.formValues.prefectures_code_id,
            one_owner_flag: this.state.formValues.one_owner_flag,
          },
          data: [],
          similarCompanyExists: similar,
          company_selected_counts: 0, // 新規登録の場合利用実績は0
          permissions: _.get(this.props, 'view.state.permissions', null),
          options: _.get(this.props, 'view.state.options', null),
        },
        jvCompanyBranchId: this.props.view.state.jvCompanyBranchId,
        parentCompanyBranchId: this.props.view.state.parent_company_branch_id,
        fieldId: this.getFieldId(),
        fieldTreeId: this.props.view.state.field_tree_id,
        jvFieldTree,
        loadFrom: this.props.view.state.loadFrom,
        callback: {
          close: () => {
            // 登録をやめる
            dialogLoader.close();
            this.updatingFlag = false;
            // 現場体制から来た場合は現場体制画面に戻る
            if (this.fromFieldTreePage()) {
              EventMg.trigger(FIELD_TREE_EVENTS.TREE_REFRESH);
              masterSlideLoader.show(
                'FieldTreePage',
                { state: { id: 1 } },
                this.props.vw
              );
              EventMg.trigger(FIELD_TREE_EVENTS.BACK_TO_MAIN, {
                update: true,
              });
            }
            // 協力会社一覧から来た場合は協力会社一覧画面に戻る
            if (this.fromPartnerCompanies()) {
              masterSlideLoader.show('PartnerCompanies', {
                state: {},
              });
            }
            if (this.fromAgencyRegister()) {
              this.props.onClose();
            }
          },
          back: () => {
            dialogLoader.close();
            this.updatingFlag = false;
          },
          submit: (formValues, confirmValues, isPartners) => {
            if (this.updatingFlag) {
              return;
            } else {
              this.updatingFlag = true;
              if (this.fromFieldTreePage()) {
                const param = {
                  parent_tree_id: formValues.parent_tree_id,
                  private_partner_company_flag:
                    formValues.private_partner_company_flag,
                  work_hour_zone_day_flag: formValues.work_hour_zone_day_flag,
                  work_hour_zone_night_flag:
                    formValues.work_hour_zone_night_flag,
                  work_hour_zone_midnight_flag:
                    formValues.work_hour_zone_midnight_flag,
                  representative: formValues.representative,
                  prime_contractors_company_branch_id:
                    formValues.prime_contractors_company_branch_id,
                  company_branch_id: formValues.company_branch_id,
                  call_from: CALL_FROM_PAGE.FIELD_TREE_PAGE,
                };

                const branchId = formValues.partner_company_branch_id;
                if (branchId && branchId !== HEAD_OFFICE_OPTION.id) {
                  param.partner_company_branch_id = branchId;
                }

                if (!isPartners) {
                  // 協力会社一覧にない場合は、協力会社一覧に登録も必要
                  // 協力会社管理者の場合は元請の一覧
                  this.confirmCreateFieldTree(formValues, confirmValues);
                  this.updatingFlag = false;
                } else {
                  FieldTreesApi.create(this.getFieldId(), param)
                    .then(response => {
                      if (response.result) {
                        this.redirectFieldtree();
                        const fieldTree = _.get(
                          response,
                          'data.entities.field_tree'
                        );
                        dialogLoader.show(
                          AddPartnerCompanyFieldTreeSuccessDialog,
                          {
                            companyName: fieldTree.company_name,
                            onConfirm: () => {
                              dialogLoader.close();
                              this.updatingFlag = false;
                              masterSlideLoader.show('PartnerBox', {
                                state: { id: fieldTree.id },
                              });
                            },
                            onCancel: () => {
                              dialogLoader.close();
                              this.updatingFlag = false;
                            },
                          }
                        );
                      } else {
                        this.showErrorDialog(response.data.message);
                      }
                    })
                    .finally(() => {
                      this.updatingFlag = false;
                    });
                }
              }
              if (this.fromPartnerCompanies()) {
                this.createNewCompany(formValues);
              }
              if (this.fromAgencyRegister()) {
                this.props.onSelectCompany(formValues);
                dialogLoader.close();
                this.props.onClose();
              }
            }
          },
          showDuplicateDialog: () => {
            this.showDuplicateDialog();
          },
          confirmCreate: (formValues, confirmValues) => {
            if (this.updatingFlag) {
              return false;
            } else {
              this.updatingFlag = true;
              if (this.fromFieldTreePage()) {
                const createFlag = true;
                return this.confirmCreateFieldTree(
                  formValues,
                  confirmValues,
                  createFlag
                );
              }
              // 類似協力会社ダイアログ => 新規登録
              // 類似協力会社のリストのstateではなく、このComponentの入力値で登録する
              if (this.fromPartnerCompanies() || this.fromAgencyRegister()) {
                return this.createNewCompany(this.state.formValues, true);
              }

              // 不正な遷移元
              return false;
            }
          },
          resetUpdatingFlag: () => {
            this.updatingFlag = false;
          },
          createCompany: data => {
            if (isNullOrEmpty(data.selected.company_number)) {
              this.createCompany(data);
            } else {
              dialogLoader.close();
              this.setState(
                {
                  formValues: {
                    ...data.selected,
                    kana: this.state.formValues.kana,
                    tel: this.state.formValues.tel,
                    parent_tree_id: this.state.formValues.parent_tree_id,
                    private_partner_company_flag: 0,
                  },
                },
                this.checkRequired
              );
              this.schema = _.omit(this.schema, 'one_owner_flag');
              this.updatingFlag = false;
            }
          },
        },
      },
      this.props.vw
    );
  };

  /**
   * 協力会社一覧から利用実績のない(is_partners = false)Buildee協力会社を追加する場合のデータ送信
   */
  createNewCompany = (formValues, createFlag) => {
    if(!this.state.isLoading) {
      this.setState({isLoading: true}, () => {
        // 協力会社一覧、または代行申請登録画面から遷移
        if (this.fromPartnerCompanies() || this.fromAgencyRegister()) {
          let juridical_personality_code = ''; // 法人格
          if (!_.isUndefined(formValues.juridical_personality_code)) {
            juridical_personality_code = formValues.juridical_personality_code;
          }

          let juridical_personality_number = ''; // 法人番号
          if (!_.isUndefined(formValues.company_number)) {
            juridical_personality_number = formValues.company_number;
          }

          let company_id = ''; // Buildee会社ID
          if (!_.isUndefined(formValues.id)) {
            company_id = formValues.id;
          }

          let company_number = ''; // 法人番号
          if (!_.isUndefined(formValues.company_number)) {
            company_number = formValues.company_number;
          }

          if (!isNullOrEmpty(formValues.company_number)) {
            formValues.personal_flag = 0;
          } else {
            formValues.personal_flag = 1;
          }

          const params = {
            is_person: formValues.personal_flag === 1,
            joining_flag: createFlag ? 0 : 1, // リストから選択の場合はBuildee加入済みなので[1]?
            name: formValues.name,
            kana: formValues.kana,
            juridical_personality_code,
            juridical_personality_number,
            postal_code: convertPostalCode(formValues.postal_code),
            prefectures_code_id: formValues.prefectures_code_id,
            city_name: formValues.city_name,
            street_number: formValues.street_number,
            building_name: formValues.building_name,
            tel: formValues.tel,
            fax: formValues.fax,
            common_partner_company_code: '', // TaxMasterListと統一するために追加(共通協力会社コード)
            company_branch: {
              // TaxMasterListと統一するために追加
              name: '',
              kana: '',
            },
            company_id,
            tax_master: {
              name: formValues.name,
              juridical_personality_code,
              juridical_personality_number,
              postal_code: convertPostalCode(formValues.postal_code),
              prefectures_code_id: formValues.prefectures_code_id,
              city_name: formValues.city_name,
              street_number: formValues.street_number,
            },
            personal_flag: formValues.personal_flag,
            company_number,
          };
          if (_.isEqual(params.personal_flag, ONE_MASTER_FLAG.personal.id)) {
            params.one_owner_flag = formValues.one_owner_flag;
          }

          // 画像セット
          if (this.state.image.isSet) {
            params.icon_image = this.state.image.file;
          }

          // 代行登録申請の場合元請会社の配下として関連付けを作成しない
          if (this.fromAgencyRegister()) {
            params.no_partner = 1;
          }

          CompanyService.create(params)
            .then(response => {
              if (response.result) {
                if (response.duplicate_flag === true) {
                  // BLDE_V2-53894: 代行登録申請・編集画面から開いている場合、会社重複時には権限エラー画面に遷移させる
                  if (
                    this.props.view.state.loadFrom ===
                    PARTNER_COMPANY_REGISTER_LOAD_FROM.AGENCY_REGISTER
                  ) {
                    return window.location.replace('/error-permission');
                  }
                  this.setState(
                    {
                      showConfirmDialog: false,
                    },
                    () => {
                      this.showDuplicateDialog();
                    }
                  );
                } else {
                  this.setState(
                    {
                      showConfirmDialog: false,
                    },
                    () => {
                      const addCompanyTitle =
                        _.get(response, 'data.entities.company.name', '') || '';
                      if (this.fromPartnerCompanies()) {
                        this.redirectPartnerCompanies();

                        dialogLoader.show(FormInformationDialog, {
                          title: '協力会社の追加完了',
                          message: `${addCompanyTitle}を追加しました。`,
                          rootClassName: addPartnerCompanySucessDialog,
                          onClose: () => {
                            dialogLoader.close();
                          },
                        });
                      }
                      if (this.fromAgencyRegister()) {
                        this.props.onSelectCompany({
                          ...response.data.entities.company,
                          company_branch: response.data.entities.company_branch,
                        });
                        this.props.onClose();
                        dialogLoader.show(FormInformationDialog, {
                          title: '協力会社の登録完了',
                          message: `${addCompanyTitle}をBuildeeに登録しました。`,
                          rootClassName: addPartnerCompanySucessDialog,
                          onClose: () => {
                            dialogLoader.close();
                          },
                        });
                      }
                    }
                  );
                }
              } else {
                // 登録失敗
                return false;
              }
            })
            .catch(() => {
              // エラー発生
              return false;
            })
            .finally(() => {
              this.setState({
                isLoading: false,
              }, () => {
                this.updatingFlag = false;
              })
            });
          return true;
        }
      })
    }

    // 施工体系図から遷移
    if (this.fromFieldTreePage()) {
      return this.confirmCreateFieldTree();
    }

    // 不正な遷移元
    return false;
  };

  showConfirmDialog = () => {
    this.setState({
      showConfirmDialog: true,
    });
  };

  showDuplicateDialog = () => {
    this.setState({
      showDuplicateDialog: true,
    });
  };

  closeDuplicateDialog = () => {
    this.setState(
      {
        showDuplicateDialog: false,
      },
      () => {
        dialogLoader.close();
        this.redirectPartnerCompanies();
      }
    );
  };

  /**
   * 登録 - 個人事業主新規登録
   */
  submit = async () => {
    if (this.validateAll() === false) {
      this.updatingFlag = false;
      return;
    }
    const isCorporate = !_.isEmpty(this.state.formValues.company_number);
    if (isCorporate) {
      // 法人新規登録
      await this.createCompany();
    } else {
      // 新規登録の流れ（自社未登録個人）
      const param = this.createFetchSimilarParam();
      const response = await CompanyService.similarityCompany(param);
      if (response.result) {
        if (response.data.total > 0) {
          // 類似会社が1件以上ある場合に類似会社一覧を表示する
          this.updatingFlag = false;
          this.showSimilarityDialog();
        } else {
          // 類似会社がないため個人事業主を登録
          await this.createCompany();
        }
      } else {
        // エラー処理
        let message = '';
        if (response.message) {
          message = response.message;
        } else {
          message = _.has(response, 'data.message')
            ? response.data.message
            : '';
        }
        this.showErrorDialog(message);
      }
    }
  };

  fromPartnerCompanies = () => {
    return loadFromPartnerCompanies(this.props.view.state.loadFrom);
  };

  fromFieldTreePage = () => {
    return loadFromFieldTreePage(this.props.view.state.loadFrom);
  };

  fromAgencyRegister = () => {
    return loadFromAgencyRegister(this.props.view.state.loadFrom);
  };

  getWorkHourZoneSetting = async () => {
    const response = await FieldApi.loadField(this.getFieldId());
    if (response.result && _.has(response, 'data.entities.field')) {
      const field = response.data.entities.field;
      const workHourZone = {
        work_hour_zone_day_flag: field.work_hour_zone_day_flag === API_FLAG.On,
        work_hour_zone_night_flag:
          field.work_hour_zone_night_flag === API_FLAG.On,
        work_hour_zone_midnight_flag:
          field.work_hour_zone_midnight_flag === API_FLAG.On,
      };
      return workHourZone;
    }
    throw new Error('現場の作業時間帯設定の取得に失敗しました。');
  };

  /**
   * 画像アップロード
   */
  setImage = e => {
    let createObjectURL =
      (window.URL || window.webkitURL).createObjectURL ||
      window.createObjectURL;
    const files = e.target.files;
    const validate = _.cloneDeep(this.state.validate);
    const image = _.cloneDeep(this.state.image);
    if (files.length > 0) {
      if (files[0].size > maxiileSize) {
        validate.messages.image = messageUtility.getMessage('E-000-011');
        image.isSet = false;
        image.path = '';
        image.file = '';
      } else {
        const url = createObjectURL(files[0]);
        this.imageExists(url, e.target, async (loaded, target) => {
          const type = await ImageUtility.fileTypeCheck(target.files[0]);
          if (loaded && type) {
            image.path = url;
            image.file = target;
            image.isSet = true;
            if (validate.messages.image) {
              delete validate.messages.image;
            }
          } else {
            validate.messages.image =
              '選択可能な画像形式は「JPEG、GIF、PNG」ファイルです';
            image.isSet = false;
            image.path = '';
            image.file = '';
          }
          this.setState({
            validate,
            image,
          });
        });
      }
    } else {
      image.path = '';
      image.file = '';
      image.isSet = false;
      if (validate.messages.image) {
        delete validate.messages.image;
      }
    }
    this.setState({
      validate,
      image,
    });
  };

  /**
   * 画像判定
   * @param url {string}
   * @param target
   * @param callback
   */
  imageExists(url, target, callback) {
    const img = new Image();
    img.src = url;
    img.onload = () => {
      callback(true, target);
    };
    img.onerror = () => {
      callback(false);
    };
  }

  /**
   * 画像削除
   */
  deleteImage = () => {
    let image = _.cloneDeep(this.state.image);
    let validate = _.cloneDeep(this.state.validate);
    image.path = '';
    image.file = '';
    image.isSet = false;
    if (validate.messages.image) {
      delete validate.messages.image;
    }
    this.setState({
      validate,
      image,
    });
    // onChangeイベントを感知
    document.getElementById('file-company-branch-image').value = '';
  };

  goBackToSearch = () => {
    // 編集画面を閉じるダイアログ表示
    dialogLoader.show(dialog.CloseEditView, {
      callback: {
        close: () => {
          dialogLoader.close();
        },
        clear: () => {
          dialogLoader.close();
          if (this.fromFieldTreePage()) {
            this.redirectFieldtree(true);
          }
          if (this.fromAgencyRegister()) {
            this.redirectAgencyRegister(true);
          }
          if (this.fromPartnerCompanies()) {
            this.redirectPartnerCompanies(true);
          }
        },
      },
    });
  };

  showErrorDialog = errorMessage => {
    this.handleVisibleDialog(true);
    this.setState({ errorMessage });
  };

  handleVisibleDialog = visibleDialogFlag => {
    this.setState({ visibleDialogFlag });
  };

  renderPageTitle = () => {
    if (this.state.formValues.personal_flag === ONE_MASTER_FLAG.personal.id) {
      return '個人事業主を新規登録';
    }
    return '協力会社を新規登録';
  };

  render() {
    const TitleHeader = () => (
      <MasterPageHeader
        title={this.renderPageTitle()}
        onClose={() => {
          this.close();
        }}
      />
    );

    return (
      <React.Fragment>
        <div className='master-slide-view show sys-splitview-1'>
          <Helmet>
            <title>{HEADER_CONSTANTS.title} - 協力会社新規登録</title>
          </Helmet>
          <div className='master-slide-view__view slide-view__view'>
            <TitleHeader />
            <div className='PartnerCompanyPersonalRegister__body'>
              <div className='contruction-detail-view'>
                <div className='contruction-detail-view__body contruction-detail-view__body--fixed'>
                  <div className='PartnerCompanyPersonalRegister__menu contruction-detail-view__menu'>
                    <button
                      className='btn--sub'
                      ref={this.submitRef}
                      onClick={() => {
                        // 重複登録防止
                        if (this.submitRef.current.disabled === false) {
                          this.close();
                          this.updatingFlag = false;
                        }
                      }}
                    >
                      登録をやめる
                    </button>
                    <button
                      className='btn'
                      ref={this.submitRef}
                      onClick={async () => {
                        // 重複登録防止
                        if (this.submitRef.current.disabled === false) {
                          if (this.updatingFlag) {
                            return;
                          }
                          this.updatingFlag = true;
                          await this.events.form.submit();
                        }
                      }}
                    >
                      次へ
                    </button>
                    <span className='--fx-auto' />
                    <div className='slide-view__header-end-item'>
                      <span className='PartnerCompanyPersonalRegister__menu__error-message'>
                        {this.state.validate.invalid
                          ? '入力エラーがあります。'
                          : ''}
                      </span>
                      <span
                        className=''
                        style={{ fontWeight: 'bold' }}
                        key={this.state.requiredInput.count}
                      >
                        {`必須項目の入力数 ${this.state.requiredInput.count}/${
                          this.state.requiredInput.total
                        }`}
                      </span>
                    </div>
                  </div>
                  <div className='contruction-detail-view__bar' />
                  <div className='contruction-detail-view__main--fixed PartnerCompanyPersonalRegister__content'>
                    <PartnerCompanyPersonalForm
                      events={this.events.form}
                      messages={this.state.validate.messages}
                      values={this.state.formValues}
                      image={this.state.image.path}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.state.showConfirmDialog && (
          <PartnerCompanyRegisterConfirmDialog
            createCompanyFlag={true}
            events={this.events.confirm}
            validate={this.state.confirmValidate}
            values={{
              company: {
                ...this.state.formValues,
              },
            }}
            visible={this.state.showConfirmDialog === true}
            loadFrom={this.props.view.state.loadFrom}
            formValues={this.state.formValues}
            workHourZoneSetting={this.state.workHourZoneSetting}
            isPartners={false} // 協力会社一覧に並んでいる場合は類似協力会社確認ダイアログが出るためこちらは常にfalse
            resetIsSelectingCompany={() => {
              this.updatingFlag = false;
            }}
          />
        )}
        <Information
          message={this.state.errorMessage}
          buttonText={messageUtility.getMessage('I-000-011')}
          visible={this.state.visibleDialogFlag}
          onClose={() => {
            this.handleVisibleDialog(false);
            this.updatingFlag = false;
          }}
        />
        <Information
          visible={this.state.showDuplicateDialog}
          title={messageUtility.getMessage('I-000-133')}
          buttonText={messageUtility.getMessage('I-000-017')} // 閉じる
          message={messageUtility.getMessage('E-000-054')}
          onClose={() => {
            this.closeDuplicateDialog();
            this.updatingFlag = false;
          }}
        />
      </React.Fragment>
    );
  }
}

const PartnerCompanyPersonalForm = ({ events, messages, values, image }) => {
  const [pciSelect, setPciSelect] = useState(false);
  const isCorporate = !_.isEmpty(values.company_number);

  return (
    <FormList>
      <FormListItem>
        {isCorporate ? (
          <Description type='primary'>
            この会社はBuildeeを利用したことがない会社です。
            <br />
            同じ名前の別会社を誤って登録しないように、会社名や住所などが正しいかご確認ください。
            <br />
            別の会社を登録する場合は再検索を行ってください。
            <button
              className='btn--sub btn--description'
              onClick={() => {
                events.goBackToSearch();
              }}
            >
              協力会社を再検索
            </button>
          </Description>
        ) : (
          <p className='text--small'>
            個人事業主を新規登録します。
            <span className='text--negative'>
              ※法人の会社はここでは新規登録しないでください。
            </span>
            <br />
            Buildeeに登録するために、必要な情報を入力してください。
          </p>
        )}
      </FormListItem>
      <FormListItem>
        <div className='form-list__label'>
          <span className='label'>種別</span>
        </div>
        <FormElement>
          {isCorporate
            ? ONE_MASTER_FLAG.corporation.name
            : ONE_MASTER_FLAG.personal.name}
        </FormElement>
      </FormListItem>
      {!isCorporate && (
        <FormListItem
          label={messageUtility.getMessage('I-000-186')}
          required={true}
        >
          <FormElement validate={messages.one_owner_flag}>
            <div className='form-list-radio'>
              {_.map(
                Object.values(PARTNER_COMPANY_PERSONAL_TYPE),
                ({ value, label }) => (
                  <div className='form-list-radio__item' key={value}>
                    <label className='radio'>
                      <input
                        type='radio'
                        name='one_owner_flag'
                        id={`one_owner_flag${value}`}
                        value={value}
                        checked={_.isEqual(value, values.one_owner_flag)}
                        onChange={e =>
                          events.handleInput(
                            'one_owner_flag',
                            Number(e.target.value)
                          )
                        }
                      />
                      <RadioButtonIcon className='icon--2x' />
                      <span>{label}</span>
                    </label>
                  </div>
                )
              )}
            </div>
          </FormElement>
        </FormListItem>
      )}
      <FormListItem
        label={
          isCorporate
            ? CORPORATION_PERSONAL_NAME.corporation_name
            : CORPORATION_PERSONAL_NAME.personal_name
        }
        required={!isCorporate}
      >
        <FormElement validate={messages.name}>
          {isCorporate ? (
            values.name
          ) : (
            <input
              className='form-list__input-large'
              id='name'
              type='text'
              name='name'
              value={values.name}
              maxLength={255}
              onChange={e => {
                events.handleInput('name', e.target.value);
              }}
              onBlur={e => {
                events.validate(e);
              }}
            />
          )}
        </FormElement>
      </FormListItem>
      <FormListItem
        label={
          isCorporate
            ? CORPORATION_PERSONAL_KANA.corporation_kana
            : CORPORATION_PERSONAL_KANA.personal_kana
        }
        required={true}
      >
        <FormElement validate={messages.kana}>
          <input
            className='form-list__input-large'
            id='kana'
            type='text'
            name='kana'
            value={values.kana}
            maxLength={255}
            onChange={e => {
              events.handleInput('kana', e.target.value);
            }}
            onBlur={e => {
              events.validate(e);
            }}
          />
        </FormElement>
      </FormListItem>
      {isCorporate && (
        <React.Fragment>
          <FormListItem label='法人格'>
            <FormElement>
              {_.get(
                _.find(LEGAL_PERSONALITIES, code => {
                  return code.id === values.juridical_personality_code;
                }),
                'name'
              )}
            </FormElement>
          </FormListItem>
          <FormListItem label='法人番号'>
            <FormElement>{values.company_number}</FormElement>
          </FormListItem>
        </React.Fragment>
      )}
      <FormListItem label='郵便番号' required={values.noPostalcode}>
        {!values.noPostalcode ? (
          <FormElement>
            {`${values.postal_code.slice(0, 3)}-${values.postal_code.slice(3)}`}
          </FormElement>
        ) : (
          <PostalCode
            value={values.postal_code}
            handleOnChange={events.handleInput}
            setKey='postal_code'
            error={messages.postal_code}
            validate={events.validate}
          />
        )}
      </FormListItem>
      {isCorporate ? (
        <FormListItem label='住所'>
          <FormElement>
            {PREFECTURE_LISTS[values.prefectures_code_id] +
              values.city_name +
              values.street_number}
          </FormElement>
        </FormListItem>
      ) : (
        <React.Fragment>
          <FormListItem label='都道府県' required={true}>
            <FormElement validate={messages.prefectures_code_id}>
              <React.Fragment>
                <select
                  name='prefectures_code_id'
                  className={pciSelect ? 'show' : ''}
                  value={values.prefectures_code_id}
                  onChange={e => {
                    if (pciSelect) {
                      setPciSelect(!pciSelect);
                    }
                    events.handleInput('prefectures_code_id', e.target.value);
                  }}
                  onBlur={e => {
                    if (pciSelect) {
                      setPciSelect(!pciSelect);
                    }
                    events.validate(e);
                  }}
                  onClick={() => {
                    setPciSelect(!pciSelect);
                  }}
                >
                  <option value=''>選択してください</option>
                  {_.map(PREFECTURE_GROUPS, (region, index) => (
                    <optgroup key={index} label={region.label}>
                      {_.map(region.prefectures, prefecture => (
                        <option key={prefecture.id} value={prefecture.id}>
                          {prefecture.name}
                        </option>
                      ))}
                    </optgroup>
                  ))}
                </select>
                <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
              </React.Fragment>
            </FormElement>
          </FormListItem>
          <FormListItem label='市区町村' required={true}>
            <FormElement validate={messages.city_name}>
              <input
                className='form-list__input-large'
                type='text'
                name='city_name'
                value={values.city_name}
                placeholder={messageUtility.getMessage('I-000-190')}
                maxLength={512}
                onChange={e => events.handleInput('city_name', e.target.value)}
                onBlur={e => {
                  events.validate(e);
                }}
              />
            </FormElement>
          </FormListItem>
          <FormListItem label={messageUtility.getMessage('I-000-188')}>
            <FormElement>
              <input
                className='form-list__input-large'
                type='text'
                name='street_number'
                value={_.defaultTo(values.street_number, '')}
                placeholder={messageUtility.getMessage('I-000-191')}
                maxLength={512}
                onChange={e =>
                  events.handleInput('street_number', e.target.value)
                }
                onBlur={e => {
                  events.validate(e);
                }}
              />
            </FormElement>
          </FormListItem>
        </React.Fragment>
      )}

      <FormListItem label='建物名・部屋番号等'>
        <FormElement validate={messages.building_name}>
          <input
            className='form-list__input-large'
            type='text'
            name='building_name'
            value={_.defaultTo(values.building_name, '')}
            placeholder='（例）赤坂ビルディング'
            maxLength={512}
            onChange={e => events.handleInput('building_name', e.target.value)}
            onBlur={events.validate ? e => events.validate(e) : null}
          />
        </FormElement>
      </FormListItem>
      <FormListItem label='電話番号' required={true}>
        <Tel
          value={values.tel}
          handleOnChange={events.handleInput}
          setKey='tel'
          error={messages.tel}
          validate={e => {
            events.validate(e, 'tel');
          }}
        />
      </FormListItem>
      <FormListItem label='FAX番号'>
        <Tel
          value={values.fax}
          handleOnChange={events.handleInput}
          setKey='fax'
          error={messages.fax}
          validate={e => {
            events.validate(e, 'fax');
          }}
        />
      </FormListItem>
      {values.joining_flag == API_FLAG.Off && (
        <CompanyLogo
          readOnly={false}
          errorMessage={messages.image}
          image={image}
          onFileUpDate={events.setImage}
          onFileDelete={events.deleteImage}
          isPerson={!isCorporate}
        />
      )}
    </FormList>
  );
};



// WEBPACK FOOTER //
// ./src/pages/PartnerCompanyPersonalRegister.jsx